<template>
  <div>
    <ul class="chart-tabs">
      <li class="all-li" :class="{'li-in': allCheck}" @click="selectAll">
        <span class="all-icon" />全选
      </li>
      <li
        v-for="(v, index) in tabs"
        :key="index"
        :style="{opacity: `${v.show === true ? 1 : 0.6}`}"
        @click="tabChange(v)"
      >
        <span
          class="icon"
          :style="{
            border: `${v.show === true ? 4 : 1}px solid ${color[index]}`
          }"
        /><span
          :style="{color: `${v.show === true ? '#333333' : '#66666'}`}"
        >{{ v.name }}</span>
      </li>
    </ul>
    <Chart
      :id="`avg-chart`"
      ref="avgChart"
      height="600px"
      width="100%"
      :options="options"
    />
  </div>
</template>

<script>
import Chart from '@/components/Chart/index.vue'

export default {
  components: {
    Chart
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    const _this = this
    return {
      allCheck: true,
      tabs: [],
      color: ['#FF6C14', '#2B89FF', '#A35DFF', '#6DD400', '#FFA100', '#00B8EC'],
      options: {
        tooltip: {
          extraCssText:
            'box-shadow: 2px 2px 4px 0px rgba(0,0,0,0.1);background: #FFFFFF;color: #333333;padding: 10px;font-size: 12px',
          trigger: 'item', // 使用 item 触发，显示每个点的信息
          formatter: function(params) {
            // 自定义提示框内容格式
            const val =
              _this.list[params.componentIndex].details[params.dataIndex]
            return (
              `<div style='color: #333;font-weight:bold;margin-bottom:5px'>${params.seriesName}（${params.name}）</div>` +
              `<div><span  style='color: #999;margin-right: 10px'>最高分</span>${val.values[0]}</div>` +
              `<div><span  style='color: #999;margin-right: 10px'>最低分</span>${val.values[1]}</div>` +
              `<div><span  style='color: #999;margin-right: 10px'>标准差</span>${val.values[2]}</div>` +
              `<div><span style='color: #999;margin-right: 10px'>均分&nbsp;&nbsp;&nbsp;</span><span style='color: #FFA100'>${val.values[3]}</span></div>` +
              `<div><span  style='color: #999;margin-right: 10px'>较标准</span><span style='color: ${
                val.values[4] >= 0 ? 'rgb(109, 212, 0)' : 'rgb(250, 100, 0)'
              }'>${
                val.values[4] >= 0 ? '+' + val.values[4] : val.values[4]
              }</span></div>`
            )
          }
        },

        // legend: {
        //   data: [],
        //   left: 0,
        //   icon: 'circle'
        // },
        grid: {
          left: '3%',
          right: '4%',
          bottom: 30,
          top: 36
        },

        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA',
              width: 2
            }
          },
          axisLabel: {
            color: '#999999'
          }
        },
        yAxis: {
          min: 0, // 设置Y轴的最小值
          max: 100,
          type: 'value',
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#EAEAEA',
              width: 1
            }
          }
        },
        series: []
      },
      list: []
    }
  },
  beforeMount() {
    const arr = []
    this.info.synthEZAvgScore.details.map((v) => {
      this.options.xAxis.data.push(v.name)
      arr.push(v.sort)
    })
    this.options.series.push({
      name: this.info.synthEZAvgScore.title,
      type: 'line',
      data: arr,
      symbolSize: 8,
      color: this.color[0]
    })
    this.tabs.push({
      show: true,
      name: this.info.synthEZAvgScore.title,
      color: this.color[0]
    })
    this.list.push(this.info.synthEZAvgScore)
    // this.options.legend.data.push(this.info.synthEZAvgScore.title)
    this.info.barChart.map((v, index) => {
      this.list.push(v)
      const arr1 = []
      v.details.map((q) => {
        arr1.push(q.sort)
      })
      this.options.series.push({
        name: v.title,
        type: 'line',
        data: arr1,
        symbolSize: 8,
        color: this.color[index + 1]
      })
      this.tabs.push({
        show: true,
        name: v.title,
        color: this.color[index + 1]
      })
      // this.options.legend.data.push(v.title)
    })
    console.info(this.list)
  },
  methods: {
    selectAll() {
      this.allCheck = !this.allCheck
      this.tabs.map((v) => {
        v.show = this.allCheck
      })
      this.resetChart()
    },
    tabChange(v) {
      v.show = !v.show
      this.resetChart()
    },
    resetChart() {
      this.options.series = []
      this.list.map((v, index) => {
        if (this.tabs[index].show) {
          const arr1 = []
          v.details.map((q) => {
            arr1.push(q.sort)
          })
          this.options.series.push({
            name: v.title,
            type: 'line',
            data: arr1,
            symbolSize: 8,
            color: this.tabs[index].color
          })
        }
      })
      this.$refs.avgChart.setOption(this.options)
      this.allCheck = this.tabs.every((v) => {
        return v.show
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-tabs {
  display: flex;
  font-weight: 600;
  padding-left: 20px;
  .li-in {
    opacity: 1 !important;
    .all-icon {
      border: 4px solid #333333 !important;
    }
  }
  .all-li {
    margin-right: 40px;
    position: relative;
    opacity: 0.6;
    &::after {
      width: 1px;
      height: 13px;
      content: "";
      background: #979797;
      right: -20px;
      position: absolute;
      top: 0;
    }
    .all-icon {
      background: #ffffff;
      border-radius: 6px;
      margin-right: 6px;
      width: 12px;
      height: 12px;
      border: 1px solid #333333;
    }
  }

  li {
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    .icon {
      background: #ffffff;
      border-radius: 6px;
      margin-right: 6px;
      width: 12px;
      height: 12px;
    }
  }
}
</style>
